import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
 stats = [
    { title: 'Open Tickets', value: 42, change: '+5 this week', type: 'danger' },
    { title: 'Resolved Today', value: 18, change: '↑ 12%', type: 'success' },
    { title: 'Pending Approvals', value: 7, change: '↓ 3', type: 'warning' },
    { title: 'Avg. Response Time', value: '2.4h', change: '↑ faster', type: 'info' },
  ];

  tickets = [
    { id: 'TCK-1001', subject: 'Onboarding: Nareshkumar', stage: 'Checker Review', status: 'Pending', assignedTo: 'RS. Gartiten', created: '03-Feb-2025' },
    { id: 'TCK-1002', subject: 'Onboarding: John Doe', stage: 'Final Approver', status: 'Approved', assignedTo: 'Sankar Ganesh', created: '02-Feb-2025' },
    { id: 'TCK-1003', subject: 'Onboarding: Jane Smith', stage: 'IT Account Creation', status: 'In Progress', assignedTo: 'IT Dept', created: '01-Feb-2025' },
  ];
  constructor() { }

  ngOnInit(): void {
  }

}
